/**
 * @generated SignedSource<<7c82f2cd1c5911d892baefa06b158047>>
 * @relayHash 5cdc9e619e9ffae1c2458a65cae82b9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b89f2b87ad307d276c00cab8c433a41fbeeaac1a710af6df64ee8225fcddef3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type ReactionsDeleteReactionMutation$variables = {
  containerId: string;
  containerType: ContainerType;
  contentId: string;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type ReactionsDeleteReactionMutation$data = {
  readonly deleteReaction: {
    readonly ari: string;
    readonly containerAri: string;
    readonly emojiId: string;
  } | null | undefined;
};
export type ReactionsDeleteReactionMutation = {
  response: ReactionsDeleteReactionMutation$data;
  variables: ReactionsDeleteReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiId"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      },
      {
        "kind": "Variable",
        "name": "containerType",
        "variableName": "containerType"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      },
      {
        "kind": "Variable",
        "name": "emojiId",
        "variableName": "emojiId"
      }
    ],
    "concreteType": "SaveReactionResponse",
    "kind": "LinkedField",
    "name": "deleteReaction",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "ari"
      },
      {
        "kind": "ScalarField",
        "name": "containerAri"
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReactionsDeleteReactionMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReactionsDeleteReactionMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "5cdc9e619e9ffae1c2458a65cae82b9e",
    "id": "3b89f2b87ad307d276c00cab8c433a41fbeeaac1a710af6df64ee8225fcddef3",
    "metadata": {},
    "name": "ReactionsDeleteReactionMutation",
    "operationKind": "mutation",
    "text": "mutation ReactionsDeleteReactionMutation($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){deleteReaction(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){ari,containerAri,emojiId}}"
  }
};
})();

(node as any).hash = "9036981d01949a3e096cd7af290a477d";

export default node;
